import { convertToProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import type { RemoteDataGraphQlResponse } from './RemoteDataGraphQlResponse.types.tsx';
import { canCallORS, fetchORSDataSSR, type PrefetchedSmartlinkData } from './fetchORSDataSSR.tsx';

const SMART_LINKS_FIRST = 4;
const FETCH_WEBLINKS_SMARTLINK_DATA = 'fetch-weblinks-smartlink-data';

type CloudId = string;

function extractWebLinkUrls(
	remoteIssueGraphqlData: RemoteDataGraphQlResponse | null | undefined,
): string[] {
	const links = remoteIssueGraphqlData?.remoteLinks?.webLinks?.links;
	if (!links) {
		return [];
	}
	return [...new Set(links.map((link) => link.href).filter(Boolean))].slice(0, SMART_LINKS_FIRST);
}

export const fetchWeblinksSmartlinkData = async (
	remoteIssueGraphqlData: RemoteDataGraphQlResponse | null | undefined,
	cloudId: CloudId,
): Promise<PrefetchedSmartlinkData[] | null> => {
	if (!canCallORS()) {
		return null;
	}

	const urls = extractWebLinkUrls(remoteIssueGraphqlData);
	const projectTypeData = remoteIssueGraphqlData?.projectType;
	const projectType = projectTypeData ? convertToProjectType(projectTypeData) : undefined;

	if (urls.length === 0) {
		return null;
	}

	return fetchORSDataSSR(urls, FETCH_WEBLINKS_SMARTLINK_DATA, projectType, cloudId);
};
